export const formatAmount = (amount) => {
    if (!amount) return "";
    const cleanedAmount = amount.replace(/[^0-9.]/g, "");
    const parts = cleanedAmount.split(".");
    const integerPart = parts[0];
    const decimalPart = parts.length > 1 ? `.${parts[1]}` : "";
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return formattedIntegerPart + decimalPart;
  };